function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';

var LanguageSelector = function LanguageSelector(_ref) {
  var data = _ref.data,
      isDesktop = _ref.isDesktop;

  if (!data) {
    return null;
  }

  var links = data.languagesList || [];
  var sliderWidth = 94 / links.length;
  var activeIndex = links.findIndex(function (item) {
    return window.location.href === item.href;
  });
  var sliderPosition = activeIndex * sliderWidth + 3;

  function setCookie(MedicalLanguageCookie, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "".concat(MedicalLanguageCookie, "=").concat(cvalue, ";").concat(expires, ";path=/");
  }

  function getCookie(MedicalLanguageCookie) {
    var name = "".concat(MedicalLanguageCookie, "=");
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showPopup = _useState2[0],
      setShowPopup = _useState2[1];

  useEffect(function () {
    if (data.prompt) {
      var cookieValue = getCookie('MedicalLanguageCookie');

      if (cookieValue !== '') {
        if (window.location.href !== cookieValue && window.location.href + '/' !== cookieValue) {
          window.location = cookieValue;
        }
      } else {
        // checking for no-prompt parameter
        if (window.location.href.indexOf('no-prompt') == -1) {
          setShowPopup(true);
        } else {
          setCookie('MedicalLanguageCookie', window.location.href.replace('?no-prompt', ''), 365);
        }
      }
    }
  }, []);

  function handleClick(event) {
    setCookie('MedicalLanguageCookie', event.target.href, 365);

    if (event.target.href === window.location.href) {
      event.preventDefault();
      setShowPopup(false);
    }
  }

  function handleSliderClick(event) {
    setCookie('MedicalLanguageCookie', event.target.href, 365);
  }

  var popupLinks = data.popupLinks;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("div", {
    className: "slider",
    style: {
      width: "".concat(sliderWidth, "%"),
      left: "".concat(sliderPosition, "%")
    }
  }), links.map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: "".concat(index === activeIndex ? 'active' : '')
    }, /*#__PURE__*/React.createElement("a", {
      href: item.href,
      onClick: handleSliderClick
    }, item.content));
  })), isDesktop && showPopup && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "popup-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup popup--choose-language"
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup__headline"
  }, data.popupHeadline.text), popupLinks.map(function (link, index) {
    return /*#__PURE__*/React.createElement("a", {
      key: index,
      className: "popup__link",
      href: link.href,
      onClick: handleClick
    }, link.content);
  })))));
};

export default LanguageSelector;